import type {Modifier} from '@dnd-kit/core';

export const FORM_EDITOR_INSERT_DROPPABLE_PREFIX = 'insert:';

const restrictSortableDragToVerticalAxis: Modifier = ({transform}) => ({
    ...transform,
    x: 0,
});

export const FORM_EDITOR_SORTABLE_OVERLAY_MODIFIERS = [restrictSortableDragToVerticalAxis];
